import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';
import { UsuarioLoginEntity } from './usuario_login_entity';
import { HandleError } from "../../components/common/utils/handleError.component";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { ClienteLogin } from "./cliente_login";
import { ReenviarMailEntity,ClientePersonaEmpresa } from '../register/entities/usuario_registro_entity';
import { ModalComponent } from '../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal';
import { UtilService } from "../../components/common/utils/util.service";
import { ShowHideInput, ShowHideInput2, ShowHideInput3 } from './show-hide-input.directive'

declare var jQuery: any;
const swal = require("sweetalert2");

@Component({
    moduleId: module.id,
    selector: 'login',
    templateUrl: 'login.template.html'
})
export class loginComponent implements OnInit {
    @ViewChild('reenviarMailModal')
    modal: ModalComponent;
    @ViewChild('cambiarPassword')
    modalPass: ModalComponent;
    @ViewChild('validacioncambiopass')
    modalValPass: ModalComponent;
    show = false;
    show2 = false;
    show3 = false;
    @ViewChild(ShowHideInput)
    input: ShowHideInput;

    @ViewChild(ShowHideInput2)
    input2: ShowHideInput2;

    @ViewChild(ShowHideInput3)
    input3: ShowHideInput3;
    usuarioLogin: UsuarioLoginEntity;
    errorMessage: string;
    showLoader: string;
    banderaBrowser: number;
    banderaIE: boolean;
    banderaCelular: boolean;
    baderaMismaContrasenia:boolean;
    private sub: any;
    @SessionStorage("usuario")
    user: any;
    @SessionStorage("usuarioLogin")
    userLogin: any;
    @SessionStorage("Token")
    Token: any;
    showLoaderModal: string = "";
    showLoaderModalPass: string = "";

    usuarioReenvio: ReenviarMailEntity = new ReenviarMailEntity();
    usuarioCambio: ReenviarMailEntity = new ReenviarMailEntity();
    usuariorecuperacion:ClientePersonaEmpresa=new ClientePersonaEmpresa();
    constructor(private sessionStorageService: SessionStorageService, private loginService: LoginService, private route: ActivatedRoute, private router: Router, private handleError: HandleError,public utilService: UtilService) { }

    login(): void {
        this.showLoader = "sk-loading";
        this.banderaIE = false;
        this.banderaCelular=false;
        this.baderaMismaContrasenia=false;
        this.loginService.login(this.usuarioLogin).subscribe(
            usuario => {
                if (usuario.Error == 0) {
                    this.user = JSON.stringify(usuario);
                    this.userLogin = JSON.stringify(this.usuarioLogin);
                    let usuarioLog = jQuery.parseJSON(this.user);
                    sessionStorage.setItem("Token", usuarioLog.Token);
                    jQuery(".root").attr("inputtoken", usuarioLog.Token);
                    this.Token = usuarioLog.Token;
                    //this.sessionStorageService.store("clienteMaestra1","1");
                    this.showLoader = "";
                    if (this.banderaBrowser == 1) {
                        this.router.navigate(["/mainView"]);
                    } else {
                        this.router.navigate(["/mainViewEmpresa"]);
                       // this.sessionStorageService.store("clienteMaestra","1");
                    }
                }
                if (usuario.Error != 0) {
                    this.showLoader = "";
                    swal({
                        title: 'Login',
                        text: usuario.Mensaje,
                        type: 'error'
                    });
                }

            },
            error => {
                this.showLoader = "";
                swal({
                    title: 'Login',
                    text: "Ha ocurrido un error al momento de iniciar sesión, podría deberse a que no se encuentran pólizas activas o inconsistencias en la información. Contáctese con Tecniseguros o su ejecutivo de cuenta",
                    type: 'error'
                });
            }
        );
    }

    checkBrowser() {
        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            //return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            this.banderaIE = true;
        } else {

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                //return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                this.banderaIE = true;
            } else {
                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    //return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                    this.banderaIE = false;
                } else {
                    // other browser
                    //return false;
                    this.banderaIE = false;
                }
            }
        }
    }
    crearCuenta() {
        this.router.navigate(["/register", this.usuarioLogin.Tipo]);
    }
    ngOnInit(): void {
        this.checkBrowser();
        this.banderaBrowser = 0;
        this.usuarioLogin = new UsuarioLoginEntity();
        sessionStorage.clear();
        this.sessionStorageService.clear();
        
        this.sub = this.route.params.subscribe(params => {
            this.usuarioLogin.Tipo = +params['bandera'];
            if (this.usuarioLogin.Tipo != 1 && this.usuarioLogin.Tipo != 2) {
                this.router.navigate(["/error404"]);
            }
            this.banderaBrowser = this.usuarioLogin.Tipo;
        });
    }

    CambiarContrasena() {
        this.router.navigate(["/cambiar-contrasena", this.usuarioLogin.Tipo]);
    }

    openModal() {
        this.baderaMismaContrasenia=false;
        this.usuariorecuperacion.Cedula="";
        this.usuarioCambio.Usuario="";
        this.usuarioCambio.Mail="";
        this.usuarioCambio.Password = "";
        this.usuarioCambio.Password1 = "";
        this.usuarioCambio.Celular="";
        this.usuarioCambio.codUsuario=0;
        this.usuarioCambio.Pin=null;
        
       
        this.usuarioReenvio.Cedula="";
        this.usuarioReenvio.Usuario="";
        this.usuarioReenvio.Mail="";
        this.usuarioReenvio.Password = "";
        this.usuarioReenvio.Password1 = "";
        this.usuarioReenvio.Celular="";
        this.usuarioReenvio.codUsuario=0;
        this.usuarioReenvio.Pin=null;
        this.modal.open();
    }

    openModalPass(){
        this.baderaMismaContrasenia=false;
        this.usuariorecuperacion.Cedula="";
        this.usuarioCambio.Usuario="";
        this.usuarioCambio.Mail="";
        this.usuarioCambio.Password = "";
        this.usuarioCambio.Password1 = "";
        this.usuarioCambio.Celular="";
        this.usuarioCambio.codUsuario=0;
        this.usuarioCambio.Pin=null;
       
        this.usuarioReenvio.Cedula="";
        this.usuarioReenvio.Usuario="";
        this.usuarioReenvio.Mail="";
        this.usuarioReenvio.Password = "";
        this.usuarioReenvio.Password1 = "";
        this.usuarioReenvio.Celular="";
        this.usuarioReenvio.codUsuario=0;
        this.usuarioReenvio.Pin=null;

        this.modalPass.open();
    }

    closeModal() {
        this.modal.close();
    }

    closeModalPass(){
        this.modalPass.close();
    }
    closeModalValPass(){
        this.modalValPass.close();
    }

    reenviarMail() {
        this.showLoaderModal = "sk-loading";
        this.usuarioReenvio.Tipo = this.banderaBrowser;
        this.usuarioReenvio.Cedula=this.usuariorecuperacion.Cedula;
        this.loginService.reenviarMailActivacion(this.usuarioReenvio).subscribe(
            result => {
                this.modal.close();
                this.showLoaderModal = "";
                if (result.Error == 0) {
                    swal({
                        title: 'Reenvio de mail',
                        text: "Por favor revise su bandeja de entrada/spam o correo no deseado, para realizar la activación de la cuenta",
                        type: 'success'
                    });
                }
                if(result.Error != 0){
                    swal({
                        title: 'Reenvio de mail',
                        text: result.Mensaje,
                        type: 'error'
                    }); 
                }
            },
            error => {
                this.showLoaderModal = "";
                console.log(error);
                this.modal.close();
                swal({
                    title: 'Reenvio de mail',
                    text: "Ha ocurrido un error al momento del reenvío del mail, lamentamos el inconveniente",
                    type: 'error'
                });
            }
        );
    }

    cambioPass(){
        this.showLoaderModalPass = "sk-loading";
        this.usuarioCambio.Tipo = this.banderaBrowser;
        this.usuarioCambio.Cedula=this.usuariorecuperacion.Cedula;
        this.loginService.CambioPassword(this.usuarioCambio).subscribe(
            result => {
                this.modalValPass.close();
                this.modalPass.close();
                this.showLoaderModalPass = "";
                if (result.Error == 0) {
                    swal({
                        title: 'Cambio contraseña',
                        text: "Por favor revise su bandeja de entrada/spam o correo no deseado, para visualizar la confirmación del cambio de contraseña",
                        type: 'success'
                    });
                }
                if(result.Error != 0){

                    swal({
                        title:'Error en el cambio contraseña',
                        text: 'El código ingresado es no es el correcto, por favor ingrese el correcto o genere nuevamente uno nuevo.',
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#A14950',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((function () {
                        this.usuarioCambio.Pin=null;
                        this.modalValPass.open();
                    }).bind(this), (function (dismiss) {
                    }).bind(this)); 
                    
                }
            },
            error => {
                this.showLoaderModalPass = "";
                console.log(error);
                this.modalPass.close();
                swal({
                    title: 'Cambio contraseña',
                    text: "Ha ocurrido un error al momento del cambio de contraseña, lamentamos el inconveniente",
                    type: 'error'
                });
            }
        );
    }
    ValidarcambioPass(){
        this.showLoaderModalPass = "sk-loading";
        
        this.usuarioCambio.Tipo = this.banderaBrowser;
        this.usuarioCambio.Cedula=this.usuariorecuperacion.Cedula;
        //this.banderaCelular=false;
        this.loginService.ValidarCambioPass(this.usuarioCambio).subscribe(
            result => {
                this.modalPass.close();
                this.showLoaderModalPass = "";
                if (result.Error == 0) {
                    this.usuarioCambio.token=result.token;
                    console.log(result.Celular.length);
                    if(result.Celular.length<10){
                    this.usuarioCambio.Celular="0"+result.Celular;
                    }
                   
                    this.modalValPass.open();
                   
                }
            },
            error => {
                this.showLoaderModalPass = "";
                console.log(error);
                this.modalPass.close();
                swal({
                    title: 'Error en el cambio contraseña',
                    text: "Ha ocurrido un error al momento del cambio de contraseña, lamentamos el inconveniente",
                    type: 'error'
                });
            }
        );
    }
    
    BuscarDatosUsuario(){
        this.showLoaderModalPass = "sk-loading";
        this.baderaMismaContrasenia=false;
        this.banderaCelular=false;
        //console.log(""+this.banderaBrowser);
        this.loginService.consultaDatosUsuario(this.usuariorecuperacion.Cedula,this.banderaBrowser).subscribe(
            result => {
                this.usuarioCambio.Mail=result.Mail;
                this.usuarioCambio.Usuario=result.Usuario;
                this.usuarioCambio.Celular=result.Celular;
                this.usuarioCambio.codUsuario=result.codUsuario;
                this.usuarioReenvio.Mail=result.Mail;
                this.usuarioReenvio.Usuario=result.Usuario;
                this.usuarioReenvio.Celular=result.Celular;
                this.usuarioReenvio.codUsuario=result.codUsuario;
                this.showLoaderModalPass = "";

                // if(result.Celular!=''){
                //     this.banderaCelular=true;
                // }
                // else{
                //     this.banderaCelular=false;
                // } 

                if (result.Error == 0) {
                    swal({
                        title: 'No se encuentra registrado el cliente en TECNISEGUROS',
                        text: "Por favor debe realizar el proceso de creación de cuenta.",
                        type: 'warning'
                    });
                    this.modalPass.close();
                }
            },
            error => {
                this.showLoaderModalPass = "";
                console.log(error);
                this.modalPass.close();
                swal({
                    title: 'Busqueda Usuario',
                    text: "Ha ocurrido un error al momento de consultar la información, lamentamos el inconveniente",
                    type: 'error'
                });
            }
        );
    }

    cambiaContrasena() {
        // if(this.usuarioCambio.Password!=this.usuarioCambio.Password1){
        //     this.baderaMismaContrasenia=false;
        //     // console.log("1");
        //     // console.log(this.usuarioCambio.Password);
        //     // console.log(this.usuarioCambio.Password1);
        // }
        // else{
        //     this.baderaMismaContrasenia=true;
        //     // console.log("1");
        //     // console.log(this.usuarioCambio.Password);
        //     // console.log(this.usuarioCambio.Password1);
        // }
        return this.usuarioCambio.Password === this.usuarioCambio.Password1 ? null : true;
    }
    toggleShow(e: any, campo: number) {
        if (campo == 1) {
            this.show = !this.show;

            if (this.show) {
                this.input.changeType("text");
            }
            else {
                this.input.changeType("password");
            }
        }
        else if (campo == 2) {
            this.show2 = !this.show2;

            if (this.show2) {
                this.input2.changeType("text");
            }
            else {
                this.input2.changeType("password");
            }
        }
        else {
            this.show3 = !this.show3;

            if (this.show3) {
                this.input3.changeType("text");
            }
            else {
                this.input3.changeType("password");
            }
        }
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/login.component.ts